'use strict';

angular.module('client.services').factory('ClassesSubjects', ['$resource', 'api_server', function ($resource, api_server) {
  return $resource(api_server + '/classes/subjects_list', {}, {get: {isArray: true, cache: true}});
}]);
